import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import getSlug from 'speakingurl';

// Import context
import { useContextProvider } from 'components/views/vod/components/PlayerWrapper/useContextProvider';

// Import utilities
import { useNextMaterial, useEventListener } from 'components/utilities';

// Import variables
import { EVENTS_NAMES } from 'helpers/variables';

const usePlayerContent = ({ type }) => {
	const { continueProgress } = useSelector((state) => state.continue_watching);
	// Get data from state
	const {
		data: { subtype, metadata },
		episodes: { next }
	} = useSelector((state) => state.movieDetails);

	const { error } = useSelector((state) => state[type]);

	const history = useHistory();

	const { fetchNextMaterial } = useNextMaterial();

	// Get data from context
	const {
		isReady,
		endMarginAction,
		endMarginActionCanceled,
		buffering,
		play,
		pause,
		isPaused,
		setFullScreen,
		setEndMargin,
		isPreview,
		closePreview,
		duration,
		updateTime,
		currentTimeProgress,
		isPreviewAvailable,
		video
	} = useContextProvider();

	// TODO
	// Check if product is avaiable / purschased by user
	const episodeId = next ? !!next.uuid : false;
	// const isAvailableIn = next ? next.available_in || [] : [];
	// const isEpisodeAvaiable = useProductAvailability(episodeId, isAvailableIn);

	const isEpisodeAvaiable = episodeId;

	// check if product is an episode
	const isEpisode = subtype === 'episode';

	const showNextEpisode =
		endMarginAction &&
		!endMarginActionCanceled &&
		next &&
		isEpisode &&
		isEpisodeAvaiable;

	const showRecommendation = endMarginAction && !isPreview && !isEpisode;

	const showContinueProgress =
		isReady && !isPreview && continueProgress?.time >= 4;

	const showBigPlayButton = isReady && isPaused;

	const handlePlayPause = () => (isPaused ? play() : pause());

	useEventListener(
		EVENTS_NAMES.ENDED,
		() => {
			if (isPreview) {
				closePreview();
			} else if (isEpisode && !endMarginActionCanceled) {
				isEpisodeAvaiable ? fetchNextMaterial(next.uuid) : history.goBack();
			} else {
				const title = getSlug(metadata.title);
				history.push(`/vod/filmy/${metadata.vod_uuid}/${title}`);
			}
		},
		video
	);

	return {
		buffering,
		isReady,
		error,
		continueProgress,
		isEpisode,
		isEpisodeAvaiable,
		handlePlayPause,
		setFullScreen,
		setEndMargin,
		duration,
		updateTime,
		currentTimeProgress,
		isPreviewAvailable,
		showNextEpisode,
		showRecommendation,
		showContinueProgress,
		showBigPlayButton
	};
};

export default usePlayerContent;
